<div>
    <a type="button" class="btn text-secondary" [routerLink]="backNavigation" (click)="backClick()">
        <i class="fa-solid fa-arrow-left"></i>
        {{backText}}
    </a>
</div>